// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"cs7Va":[function(require,module,exports) {
class MassSchedules {
    constructor(){
        this.form = document.querySelector("#mass-schedules-filter-form");
        if (!this.form) return;
        this.handleFormSubmit();
        this.handleCityChange();
        this.handleRegionChange();
        this.handleSectorPreselect();
        this.handleClearFilters();
        this.handlePagination();
    }
    activeLoader() {
        const loader = document.querySelector("#mass-schedules-loader");
        if (loader) loader.classList.remove("hidden");
        const fields = this.form.querySelectorAll("input, button, select");
        fields.forEach((field)=>field.setAttribute("disabled", "true"));
    }
    handleFormSubmit() {
        this.form.addEventListener("submit", (event)=>{
            event.preventDefault();
            const url = new URL(window.location.href);
            const fields = [
                "city",
                "neighborhood",
                "weekday",
                "period",
                "region",
                "setor"
            ];
            fields.forEach((field)=>url.searchParams.delete(field));
            const formData = new FormData(this.form);
            formData.forEach((value, key)=>{
                if (value !== "" && value !== null) url.searchParams.set(key, value);
            });
            this.activeLoader();
            location.replace(url.toString());
        });
    }
    handleCityChange() {
        const citySelect = document.querySelector("#mass-schedules-city");
        if (!citySelect) return;
        citySelect.addEventListener("change", ()=>{
            const url = new URL(window.location.href);
            url.searchParams.delete("neighborhood");
            if (citySelect.value) url.searchParams.set("city", citySelect.value);
            else url.searchParams.delete("city");
            this.activeLoader();
            location.replace(url.toString());
        });
    }
    handleRegionChange() {
        const regionSelect = document.querySelector("#mass-schedules-region");
        if (!regionSelect) return;
        regionSelect.addEventListener("change", ()=>{
            this.populateSectors(regionSelect);
        });
    }
    handleSectorPreselect() {
        const regionSelect = document.querySelector("#mass-schedules-region");
        if (regionSelect) this.populateSectors(regionSelect);
    }
    populateSectors(regionSelect) {
        const sectorSelect = document.querySelector("#mass-schedules-sector");
        if (!sectorSelect) return;
        const currentSector = sectorSelect.getAttribute("data-sector");
        const sectorLabel = sectorSelect.getAttribute("data-sector-label") || "Setor";
        const selectedOption = regionSelect.options[regionSelect.selectedIndex];
        const raw = selectedOption?.getAttribute("data-item");
        sectorSelect.innerHTML = `<option value="">Selecione um ${sectorLabel}</option>`;
        if (!raw) return;
        let data;
        try {
            data = JSON.parse(raw);
        } catch (error) {
            return;
        }
        if (!data.sectors) return;
        data.sectors.forEach((sector)=>{
            const option = document.createElement("option");
            option.value = sector.id;
            option.innerText = sector.name;
            if (currentSector && currentSector == sector.id) option.selected = true;
            sectorSelect.appendChild(option);
        });
    }
    handleClearFilters() {
        const button = document.querySelector("#mass-schedules-clear");
        if (!button) return;
        button.addEventListener("click", ()=>{
            const url = new URL(window.location.href);
            [
                "city",
                "neighborhood",
                "weekday",
                "period",
                "region",
                "setor"
            ].forEach((field)=>{
                url.searchParams.delete(field);
            });
            this.activeLoader();
            location.replace(url.toString());
        });
    }
    handlePagination() {
        const paginationItems = document.querySelectorAll("#mass-schedules-pagination .pagination-item");
        paginationItems.forEach((item)=>{
            const page = item.getAttribute("data-page");
            if (!page) return;
            const url = new URL(window.location.href);
            item.href = `${item.href}page/${page}/?${url.searchParams.toString()}`;
        });
    }
}
document.addEventListener("DOMContentLoaded", ()=>{
    new MassSchedules();
});

},{}]},["cs7Va"], "cs7Va", "parcelRequire734e")

//# sourceMappingURL=mass-schedules.js.map
